import { Field, StepHeader, NavButtons } from "../common";
import { useSession } from "../../lib/session";

const GENERAL = ["Pallor", "Icterus", "Cyanosis", "Clubbing", "Lymphadenopathy", "Edema", "Dehydration"];
const SYSTEMS = [
  ["cvs", "Cardiovascular system", "Heart sounds, murmurs, JVP, peripheral pulses, CRT"],
  ["rs", "Respiratory system", "Work of breathing, air entry, breath sounds, crackles, wheeze"],
  ["abdomen", "Abdomen", "Tenderness, guarding, organomegaly, ascites, bowel sounds"],
  ["cns", "Central nervous system", "Pupils, focal deficits, neck stiffness, tone, reflexes, plantars"],
  ["musculoskeletal", "Musculoskeletal", "Joints, compartments, trauma"],
  ["skin", "Skin & others", "Rash, purpura, pressure injuries, lines, wounds"],
];

export default function ExamStep({ onRefine }) {
  const { state, set } = useSession();
  const g = state.exam.general;
  return (
    <div>
      <StepHeader num={4} title="Examination" sub="General examination followed by system-by-system findings." />
      <h2 className="font-heading text-lg font-semibold mb-4">General examination</h2>
      <Field id="appearance" label="General appearance / built / consciousness" multiline rows={2} value={g.appearance} onChange={(x) => set("exam.general.appearance", x)} />
      <div className="grid grid-cols-2 md:grid-cols-4 gap-2 mt-4">
        {GENERAL.map((k) => {
          const id = k.toLowerCase();
          const val = g[id];
          return (
            <div key={k} className="border rounded-md bg-card p-3">
              <div className="text-sm font-medium mb-2">{k}</div>
              <div className="flex gap-1">
                {["Present", "Absent"].map((o) => (
                  <button key={o} data-testid={`exam-${id}-${o.toLowerCase()}`} onClick={() => set(`exam.general.${id}`, val === o ? "" : o)}
                    className={`cc-toggle flex-1 text-xs ${val === o ? (o === "Present" ? "is-on-red" : "is-on") : ""}`}>{o}</button>
                ))}
              </div>
            </div>
          );
        })}
      </div>
      <div className="mt-4"><Field id="general-other" label="Other general findings" value={g.other} onChange={(x) => set("exam.general.other", x)} /></div>
      <h2 className="font-heading text-lg font-semibold mt-10 mb-4">Systemic examination</h2>
      <div className="grid md:grid-cols-2 gap-4">
        {SYSTEMS.map(([id, lb, ph]) => (
          <Field key={id} id={`sys-${id}`} label={lb} placeholder={ph} multiline value={state.exam.systems[id]} onChange={(x) => set(`exam.systems.${id}`, x)} />
        ))}
      </div>
      <NavButtons onBack={() => set("step", 2)} onNext={onRefine} nextLabel="Refine DDx & order investigations" />
    </div>
  );
}
